<template>
    <div class="field">
        <label :class="{ 'is-danger': errors.hasError( name ) }" :for="name" class="checkbox">
            <input :checked="value" @change="handleInput" :id="name" :name="name" type="checkbox" class="checkbox">
            <span v-text="label"></span> <a :href="link" class="iubenda-nostyle no-brand iubenda-embed " title="Privacy Policy">Privacy Policy</a>
        </label>
        <p v-if="errors.hasError( name )" class="help is-danger" v-t="(errors.get( name ))"></p>
    </div>
</template>
<script>
    export default {
        props: ['value', 'label', 'name', 'link', 'errors'],
        methods: {
            handleInput(e) {
                this.$emit('input', e.target.checked)
                this.errors.clear( this.name )
            }
        }
    }
</script>